export default __webpack_public_path__ + "static/media/buddy-gac-board.708e7c23.png";